// Ключи запросов сущностей.
//
// Форм было три: позиционная (`['deals', ws, stage, companyId, contactId]`),
// объект с полным набором полей (`['tasks', ws, {q, status, …}]`) и
// `JSON.stringify(filters)` у документов. Последняя ломалась молча: строка
// зависит от порядка полей в объекте, поэтому `{type, status}` и
// `{status, type}` — два разных ключа с одинаковым запросом, то есть лишняя
// загрузка и разъезжающийся кэш. Позиционная форма ломалась иначе: новый
// фильтр требовал править сигнатуру и все её вызовы.
//
// Здесь одна форма на все сущности:
//
//   список   → ['<сущности>', workspaceId, {нормализованные фильтры}]
//   карточка → ['<сущности>', workspaceId, id, …уточнение]
//
// Общий корень важен для инвалидации: `['deals', workspaceId]` накрывает и
// списки с любыми фильтрами, и открытую карточку.

/** Значение фильтра в том виде, в каком его отдаёт форма или URL. */
export type QueryFilterValue = string | number | boolean | null | undefined;

export type EntityListKey = readonly [string, string, Record<string, string>];

/**
 * Ключ списка. Пустые фильтры (`undefined`, `null`, пустая строка, строка из
 * пробелов) выбрасываются: «фильтр не задан» и «фильтр задан пустым» — это
 * один и тот же запрос, и они обязаны делить кэш.
 */
export function entityListKey(
  entity: string,
  workspaceId: string,
  filters: Record<string, QueryFilterValue> = {},
): EntityListKey {
  const normalized: Record<string, string> = {};

  // Ключи сортируем, чтобы порядок полей в объекте фильтров ни на что не влиял.
  for (const name of Object.keys(filters).sort()) {
    const value = filters[name];
    if (value === undefined || value === null) continue;

    const text = typeof value === 'string' ? value.trim() : String(value);
    if (text.length === 0) continue;

    normalized[name] = text;
  }

  return [entity, workspaceId, normalized] as const;
}

/**
 * Ключ карточки и её вложенных данных: `['deals', ws, id, 'stage-history']`.
 * Корень тот же, что у списка, — инвалидация префикса обновляет и карточку.
 */
export function entityDetailKey(
  entity: string,
  workspaceId: string,
  id: string,
  ...detail: string[]
): readonly string[] {
  return [entity, workspaceId, id, ...detail] as const;
}
